module.exports = __webpack_public_path__ + "img/namecard.ai.284ff396.png";